export const langId: {
  en: 'en';
  id: 'id';
} = {
  en: 'en',
  id: 'id',
};

export const langNames = {
  en: 'English',
  id: 'Bahasa',
};

export type LangID = keyof typeof langId;
